import { Controller } from "@hotwired/stimulus"

// Submits its form when asked to: straight away (submit), or once typing has paused (debounce, for a search box, so it does
// not send a request per keystroke). delay is the pause in milliseconds.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  submit() {
    this.element.requestSubmit()
  }

  debounce() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
